<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-4 mb-3">
            <div class="card-title">{{ $t("malware.search-report") }}</div>
            <div class="row">
              <div class="col-8 mr-0 pr-0">
                <div class="search-box h-100">
                  <div class="position-relative pr-2 h-100">
                    <input
                      v-model="searchKey"
                      type="text"
                      class="form-control form-control-sm h-100 rounded"
                      :placeholder="$t('malware.search-title')"
                    />
                    <i class="bx bx-search-alt bx-xs search-icon h-100"></i>
                  </div>
                </div>
              </div>
              <div class="col-2 px-0 mx-0">
                <div class="d-flex">
                  <button
                    @click="searchReport"
                    title="Search Report"
                    type="button"
                    class="btn btn-block mr-2"
                    :class="theme == 'dark' ? 'btn-primary' : 'btn-primary'"
                  >
                    <span
                      class="d-flex justify-content-center align-items-center"
                      v-if="!loading.search"
                    >
                      <i class="bx bx-search mr-2 bx-xs"></i>
                      {{ $t("malware.search") }}
                    </span>
                    <span
                      class="d-flex justify-content-center align-items-center"
                      v-if="loading.search"
                    >
                      <i class="bx bx-loader-alt bx-spin mr-2"></i>
                      {{ $t("malware.searching") }}
                    </span>
                  </button>
                  <button
                    title="Advanced Filter"
                    type="button"
                    class="btn"
                    :class="theme == 'dark' ? 'btn-primary' : 'btn-primary'"
                    v-b-toggle="'advanced-search'"
                    @click="refresh"
                  >
                    <span
                      class="d-flex justify-content-center align-items-center"
                    >
                      <i class="bx bx-filter mr-2 bx-xs"></i>
                      {{ $t("malware.advanced") }}
                    </span>
                  </button>
                </div>
              </div>
              <div class="col-2" v-if="role == 'admn' || role == 'anly'">
                <router-link to="/malware/create-report">
                  <button
                    type="button"
                    class="btn btn-block"
                    :class="theme == 'dark' ? 'btn-success' : 'btn-success'"
                  >
                    <span
                      class="d-flex justify-content-center align-items-center"
                    >
                      <i class="bx bxs-file-plus bx-xs mr-2"></i>
                      {{ $t("malware.create-report") }}
                    </span>
                  </button>
                </router-link>
              </div>
            </div>
          </div>
          <div class="px-3">
            <b-collapse id="advanced-search" class="mt-1">
              <hr class="mt-4 mb-0" />
              <div class="py-4">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="validationCustom02">{{
                        $t("malware.status-report")
                      }}</label>
                      <select
                        name="status_report"
                        id="status_report"
                        class="form-control"
                        v-model="advancedSearch.status_report"
                      >
                        <option value="">{{ $t("malware.all") }}</option>
                        <option value="0">{{ $t("malware.draft") }}</option>
                        <option value="1">{{ $t("malware.pending") }}</option>
                        <option value="2">{{ $t("malware.not-valid") }}</option>
                        <option value="3">{{ $t("malware.valid") }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="validationCustom02">{{
                        $t("malware.reported-by")
                      }}</label>
                      <select
                        name=""
                        id=""
                        class="form-control"
                        v-model="advancedSearch.report_by"
                      >
                        <option value="">{{ $t("malware.all") }}</option>
                        <option
                          v-for="adm in tableDataAdmin"
                          :key="adm.id_user"
                          :value="adm.id_user"
                        >
                          {{ adm.username }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="validationCustom03">{{
                        $t("malware.verified-by")
                      }}</label>
                      <select
                        name="verify"
                        id=""
                        class="form-control"
                        v-model="advancedSearch.verif_by"
                      >
                        <option value="">{{ $t("malware.all") }}</option>
                        <option
                          v-for="adm in tableDataVerif"
                          :key="adm.id_user"
                          :value="adm.id_user"
                        >
                          {{ adm.username }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="validationCustom05">{{
                        $t("malware.start-date-range")
                      }}</label>
                      <input
                        id="validationCustom05"
                        type="date"
                        class="form-control"
                        v-model="advancedSearch.start_created_at"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="validationCustom06">
                        {{ $t("malware.end-date-range") }}</label
                      >
                      <input
                        id="validationCustom06"
                        type="date"
                        class="form-control"
                        v-model="advancedSearch.end_created_at"
                      />
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="validationCustom04">Tag</label>
                      <input
                        type="text"
                        name="tag"
                        class="form-control"
                        v-model="advancedSearch.tag"
                        :placeholder="$t('malware.example')"
                      />
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="validationCustom04">{{
                        $t("malware.max-risk-score")
                      }}</label>
                      <vue-slide-bar
                        ref="riskscore"
                        v-model="advancedSearch.riskscore"
                        :min="0"
                        :max="100"
                      />
                      <b-button-group class="mt-1 btn-group-sm">
                        <b-button
                          variant="secondary"
                          @click="advancedSearch.riskscore -= 1"
                        >
                          <i class="fas fa-minus"></i>
                        </b-button>
                        <b-form-input
                          ref="input-size"
                          size="sm"
                          for="text"
                          :value="advancedSearch.riskscore"
                          maxlength="4"
                          v-model="advancedSearch.riskscore"
                          style="width: 35px"
                        ></b-form-input>
                        <b-button
                          variant="secondary"
                          @click="advancedSearch.riskscore += 1"
                        >
                          <i class="fas fa-plus"></i>
                        </b-button>
                      </b-button-group>
                    </div>
                  </div>

                  <div class="col-12 text-right">
                    <button
                      title="Search Report"
                      type="button"
                      class="btn mr-2 px-4"
                      @click="ResetSearchAdvanced"
                      :class="theme == 'dark' ? 'btn-danger' : 'btn-danger'"
                    >
                      <span
                        class="d-flex justify-content-center align-items-center"
                      >
                        <i class="bx bx-revision mr-2 bx-xs"></i>
                        {{ $t("malware.reset") }}
                      </span>
                    </button>
                    <button
                      title="Search Report"
                      type="button"
                      class="btn mr-2 px-4"
                      @click="searchAdvanced"
                      :class="theme == 'dark' ? 'btn-primary' : 'btn-primary'"
                    >
                      <span
                        class="d-flex justify-content-center align-items-center"
                        v-if="!loading.search"
                      >
                        <i class="bx bx-search mr-2 bx-xs"></i>
                        {{ $t("malware.search") }}
                      </span>
                      <span
                        class="d-flex justify-content-center align-items-center"
                        v-if="loading.search"
                      >
                        <i class="bx bx-loader-alt bx-spin mr-2"></i>
                        {{ $t("malware.searching") }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row mb-3 py-2 rounded"
      style="margin-right: 1px; margin-left: 1px"
      :style="
        theme == 'dark'
          ? 'background-color: #04232f'
          : 'background-color: #ffffff'
      "
    >
      <div class="col-6">
        <div class="d-flex align-items-center">
          <span class="mr-1"> Show </span>
          <b-form-select
            style="width: 8%"
            class="mr-2"
            v-model="perPage"
            :options="pageOptions"
            v-on:change="onChangePageSize"
          ></b-form-select>
        </div>
      </div>
      <div class="col-6">
        <b-button-group class="float-right">
          <b-button
            title="Grid Display"
            :variant="
              display == 'grid'
                ? 'primary'
                : theme == 'dark'
                ? 'light'
                : 'light'
            "
            @click="changeDisplay('grid')"
          >
            <i class="bx bxs-grid-alt"></i>
          </b-button>
          <b-button
            title="List Display"
            :variant="
              display == 'list'
                ? 'primary'
                : theme == 'dark'
                ? 'light'
                : 'light'
            "
            @click="changeDisplay('list')"
          >
            <i class="bx bx-list-ul"></i>
          </b-button>
        </b-button-group>
        <b-button
          title="Refresh"
          variant="light"
          class="float-right mr-2"
          @click="listReport"
        >
          <i
            class="bx bx-rotate-right"
            :class="loading.list ? 'bx-spin' : ''"
          ></i>
        </b-button>
      </div>
    </div>
    <div class="loading text-center mt-5" v-if="loading.list">
      <div class="text-center">
        <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
        <span class="font-size-16"> Loading... </span>
      </div>
    </div>
    <div class="" v-if="!loading.list">
      <div v-if="pageOfItems.length != 0">
        <div class="row" v-if="display == 'grid'">
          <div
            v-for="(rp, idx) in pageOfItems"
            :key="idx"
            class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-3"
          >
            <div class="card h-100">
              <div class="card-body">
                <div class="avatar-md mr-4 mb-3 mx-auto">
                  <span
                    class="
                      avatar-title
                      rounded-circle
                      bg-light
                      text-danger
                      font-size-16
                    "
                  >
                    <img
                      v-if="rp.malware_logo"
                      :src="
                        require('@/assets/images/malware-icon/' +
                          rp.malware_logo)
                      "
                      alt
                      height="50"
                    />
                  </span>
                </div>
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <h5 class="font-weight-bold">{{ $t("malware.report") }}</h5>
                    <div class="row border-top pt-2">
                      <div class="col-lg-4">
                        <span class="font-weight-bold">{{
                          $t("malware.title")
                        }}</span>
                      </div>
                      <div class="col-lg-8">
                        {{ rp.title }}
                      </div>
                      <div class="col-lg-4">
                        <span class="font-weight-bold">{{
                          $t("malware.description")
                        }}</span>
                      </div>
                      <div
                        class="col-lg-8"
                        style="min-height: 100px !important"
                      >
                        <span class="text-justify">
                          <readmore :text="rp.description"></readmore>
                        </span>
                      </div>
                    </div>
                    <div class="row mt-5">
                      <div class="col-lg-12 mb-5">
                        <h5 class="font-weight-bold">Malware</h5>
                        <div
                          class="row border-top pt-2"
                          v-if="rp.malware_data[0]"
                        >
                          <div class="py-1 col-lg-4 font-weight-bold">
                            {{ $t("malware.threat-name") }}
                          </div>
                          <div class="py-1 col-lg-8">
                            {{
                              rp.malware_data[0]
                                ? rp.malware_data[0].threat_name
                                : "-"
                            }}
                          </div>
                          <div class="py-1 col-lg-4 font-weight-bold">Tags</div>
                          <div class="py-1 col-lg-8">
                            <div v-if="rp.tags.length != 0">
                              <span
                                class="badge badge-soft-info px-1 mr-2"
                                v-for="(tag, id) in rp.tags"
                                :key="id"
                                >{{ tag }}</span
                              >
                            </div>
                            <div v-else>
                              <span>--</span>
                            </div>
                          </div>
                          <div class="py-1 col-lg-4 font-weight-bold">MD5</div>
                          <div class="py-1 col-lg-8">
                            {{
                              rp.malware_data[0] ? rp.malware_data[0].md5 : "-"
                            }}
                          </div>
                        </div>
                        <div class="row border-top pt-2" v-else>
                          <div class="py-1 col-lg-4 font-weight-bold">
                            {{ $t("malware.threat-name") }}
                          </div>
                          <div class="py-1 col-lg-8">-</div>
                          <div class="py-1 col-lg-4 font-weight-bold">Tags</div>
                          <div class="py-1 col-lg-8">-</div>
                          <div class="py-1 col-lg-4 font-weight-bold">MD5</div>
                          <div class="py-1 col-lg-8">-</div>
                        </div>
                      </div>
                      <div class="col-lg-6 text-center">
                        <div class="">
                          <i class="bx bx-message-alt-add mr-1"></i>
                          <span class="font-weight-bold">{{
                            $t("malware.reported-by")
                          }}</span>
                        </div>
                        <router-link
                          class="text-dark"
                          :to="{
                            path: '/malware/user/detail',
                            query: { id: getId(rp.report_by.id_user) },
                          }"
                        >
                          <div class="mx-auto">
                            <div class="avatar-sm mx-auto">
                              <img
                                :src="urlImage + rp.report_by.avatar"
                                class="rounded-circle header-profile-user"
                                alt="avatar"
                                v-if="rp.report_by.avatar"
                              />
                              <img
                                src="@/assets/images/users/avatar-10.jpg"
                                class="rounded-circle header-profile-user"
                                alt="avatar"
                                v-else
                              />
                            </div>
                            <p class="p-0 m-0">
                              {{
                                rp.report_by != null ? rp.report_by.name : "-"
                              }}
                            </p>
                          </div>
                        </router-link>
                      </div>
                      <div class="col-lg-6 text-center">
                        <div class="">
                          <i class="bx bx-check-circle mr-1"></i>
                          <span class="font-weight-bold">{{
                            $t("malware.verified-by")
                          }}</span>
                        </div>
                        <router-link
                          class="text-dark"
                          :to="{
                            path: '/malware/user/detail',
                            query: { id: getId(rp.verify_by.id_user) },
                          }"
                          v-if="
                            rp.status_report !== '1' && rp.status_report !== '0'
                          "
                        >
                          <div class="mx-auto">
                            <div class="avatar-sm mx-auto">
                              <div>
                                <div v-if="rp.verify_by">
                                  <img
                                    :src="urlImage + rp.verify_by.avatar"
                                    class="rounded-circle header-profile-user"
                                    alt="avatar"
                                    v-if="rp.verify_by.avatar"
                                  />
                                  <img
                                    src="@/assets/images/users/avatar-10.jpg"
                                    class="rounded-circle header-profile-user"
                                    alt="avatar"
                                    v-else
                                  />
                                </div>
                              </div>
                            </div>

                            <span>
                              {{
                                rp.status_report != "1"
                                  ? rp.verify_by != null
                                    ? rp.verify_by.name
                                    : "-"
                                  : "-"
                              }}
                            </span>
                          </div>
                        </router-link>
                        <div class="mx-auto" v-else>
                          <div class="avatar-sm mx-auto">
                            <br />
                            <br />
                          </div>

                          <span> - </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-4 py-3 border-top">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item mr-3">
                    <span
                      v-if="rp.status_report === '3'"
                      class="badge badge-success"
                      >{{ $t("malware.valid") }}</span
                    >
                    <span
                      v-if="rp.status_report === '2'"
                      class="badge badge-danger"
                      >{{ $t("malware.not-valid") }}</span
                    >
                    <span
                      v-if="rp.status_report === '1'"
                      class="badge badge-info"
                      >{{ $t("malware.pending") }}</span
                    >
                    <span
                      v-if="rp.status_report === '0'"
                      class="badge badge-warning"
                      >{{ $t("malware.draft") }}</span
                    >
                  </li>
                  <li
                    v-b-tooltip.hover.top
                    class="list-inline-item mr-3"
                    title="Reported Date"
                  >
                    <i class="bx bx-calendar mr-1"></i>
                    {{ rp.created_at }}
                  </li>
                  <li
                    v-b-tooltip.hover.top
                    class="list-inline-item mr-3"
                    title="Comment"
                  >
                    <i class="bx bx-message mr-1"></i>
                    {{ rp.comments_count }}
                  </li>
                  <li class="list-inline-item float-right">
                    <router-link
                      :to="{
                        path: '/malware/detail-report',
                        query: { id: getId(rp.id_report) },
                      }"
                    >
                      <button type="button" class="btn btn-primary btn-sm">
                        {{ $t("malware.view-details") }}
                      </button>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- list -->
        <div class="row" v-if="display == 'list'">
          <div class="col-lg-12">
            <div class>
              <div class="table-responsive">
                <table
                  class="
                    table
                    project-list-table
                    table-centered table-borderless
                  "
                >
                  <thead>
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col"></th>
                      <th scope="col">Report</th>
                      <th scope="col">Malware</th>
                      <th scope="col">Tags</th>
                      <th scope="col">Status</th>
                      <th scope="col">Report By</th>
                      <th scope="col">Verify By</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(rp, idx) in pageOfItems" :key="idx">
                      <td>{{ rp.no }}</td>
                      <td>
                        <div class="avatar-md mr-4 mb-3 mx-auto">
                          <span
                            class="
                              avatar-title
                              rounded-circle
                              bg-light
                              text-danger
                              font-size-16
                            "
                          >
                            <img
                              v-if="rp.malware_logo"
                              :src="
                                require('@/assets/images/malware-icon/' +
                                  rp.malware_logo)
                              "
                              alt
                              height="50"
                            />
                          </span>
                        </div>
                      </td>
                      <td width="30%">
                        <div class="d-flex">
                          <div class="w-100 ml-2">
                            <h5 class="text-truncate font-size-14">
                              {{ rp.title }}
                            </h5>
                            <p
                              class="
                                text-muted
                                mb-0
                                text-truncate text-justify text-wrap
                              "
                            >
                              <readmore :text="rp.description"></readmore>
                            </p>
                            <hr class="my-1 p-0" />
                            <ul class="list-inline mb-0">
                              <li
                                v-b-tooltip.hover.top
                                class="list-inline-item mr-3"
                                title="Reported Date"
                              >
                                <i class="bx bx-calendar mr-1"></i>
                                {{ rp.created_at }}
                              </li>
                              <li
                                v-b-tooltip.hover.top
                                class="list-inline-item mr-3"
                                title="Comment"
                              >
                                <i class="bx bx-message mr-1"></i>
                                {{ rp.comments_count }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </td>
                      <td width="20%" class="align-top">
                        <div class="text-truncate font-size-14">
                          {{
                            rp.malware_data[0]
                              ? rp.malware_data[0].threat_name
                              : "-"
                          }}
                        </div>
                        <div>
                          <small
                            >MD5 ({{
                              rp.malware_data[0] ? rp.malware_data[0].md5 : "-"
                            }})</small
                          >
                        </div>
                      </td>
                      <td width="10%">
                        <div v-if="rp.tags.length != 0">
                          <span
                            class="badge badge-soft-info px-1 mr-2"
                            v-for="(tag, id) in rp.tags"
                            :key="id"
                            >{{ tag }}</span
                          >
                        </div>
                        <div v-else>
                          <span>--</span>
                        </div>
                      </td>
                      <td>
                        <span
                          v-if="rp.status_report === '3'"
                          class="badge badge-success"
                          >Valid</span
                        >
                        <span
                          v-if="rp.status_report === '2'"
                          class="badge badge-danger"
                          >Not Valid</span
                        >
                        <span
                          v-if="rp.status_report === '1'"
                          class="badge badge-info"
                          >Pending</span
                        >
                        <span
                          v-if="rp.status_report === '0'"
                          class="badge badge-warning"
                          >Draft</span
                        >
                      </td>
                      <td>
                        <router-link
                          class="text-dark"
                          :to="{
                            path: '/malware/user/detail',
                            query: { id: getId(rp.report_by.id_user) },
                          }"
                        >
                          <div class="team">
                            <div class="team-member d-inline-block">
                              <img
                                src="@/assets/images/users/avatar-10.jpg"
                                alt
                                class="img-thumbnail rounded-circle avatar-sm"
                              />
                            </div>
                          </div>
                          <span>{{
                            rp.report_by != null ? rp.report_by.name : "-"
                          }}</span>
                        </router-link>
                      </td>
                      <td class="text-center">
                        <router-link
                          class="text-dark"
                          :to="{
                            path: '/malware/user/detail',
                            query: { id: getId(rp.verify_by.id_user) },
                          }"
                          v-if="
                            rp.status_report !== '1' && rp.status_report !== '0'
                          "
                        >
                          <div class="team">
                            <div class="team-member d-inline-block">
                              <img
                                :src="urlImage + rp.verify_by.avatar"
                                v-if="rp.verify_by.avatar"
                                alt
                                class="img-thumbnail rounded-circle avatar-sm"
                              />
                              <img
                                v-else
                                src="@/assets/images/users/avatar-10.jpg"
                                alt
                                class="img-thumbnail rounded-circle avatar-sm"
                              />
                            </div>
                          </div>
                          <span>
                            {{
                              rp.status_report != "1"
                                ? rp.verify_by != null
                                  ? rp.verify_by.name
                                  : "-"
                                : "-"
                            }}
                          </span>
                        </router-link>
                        <div v-else>
                          <div class="team">
                            <br />
                            <br />
                          </div>
                          <span> - </span>
                        </div>
                      </td>
                      <td>
                        <router-link
                          :to="{
                            path: '/malware/detail-report',
                            query: { id: getId(rp.id_report) },
                          }"
                        >
                          <button type="button" class="btn btn-primary btn-sm">
                            View Details
                          </button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- list -->
      </div>
      <div v-else>
        <div class="text-center mt-5">
          <img
            :src="require('@/assets/images/no-results.png')"
            alt
            height="200"
          />
          <h2 class="mt-2">Not Found</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div
          class="col-lg-12 mb-5"
          :class="theme == 'dark' ? 'custom-paginate-dark' : 'custom-paginate'"
        >
          <center>
            <jw-pagination
              ref="paginate"
              :items="reports"
              :pageSize="perPage"
              :labels="labelsPaginate"
              @changePage="onChangePage"
            ></jw-pagination>
          </center>
        </div>
      </div>
    </div>
    <!-- end ro w -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ReportService from "@/helpers/report.service";
import { userService } from "@/helpers/authservice/user.service";
import { Buffer } from "buffer";
import moment from "moment";
import JwPagination from "jw-vue-pagination";
import Readmore from "../../../components/widgets/readmore.vue";

import VueSlideBar from "vue-slide-bar";
import UserService from "@/helpers/user.service";
import { projectData } from "./data-projects";

/**
 * Projects-grid component
 */
export default {
  page: {
    title: "Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, JwPagination, VueSlideBar, Readmore },
  data() {
    return {
      role: this.$store.state.authBackend.role,
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      projectData: projectData,
      title: this.$t("malware.report-analysis"),
      tableDataAdmin: [],
      tableDataVerif: [],
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("malware.report-analysis"),
          active: true,
        },
      ],
      theme: localStorage.getItem("theme") ?? "light",
      reports: [],
      loading: {
        list: false,
        search: false,
      },
      searchKey: "",
      display: "grid",
      pageOfItems: [],
      perPage: 15,
      pageOptions: [15, 30, 45, 60],
      labelsPaginate: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
      riskscore: 0,
      advancedSearch: {
        status_report: "",
        report_by: "",
        start_created_at: "",
        end_created_at: "",
        verif_by: "",
        riskscore: 0,
        tag: "",
      },
    };
  },
  watch: {
    refreshSlider: {
      immediate: true,
      handler(n) {
        if (n) {
          this.refresh();
        }
      },
    },
  },
  methods: {
    listReport() {
      let ferr = 0;
      this.loading.list = true;
      ReportService.list()
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.listReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            res.data.data.forEach((el, idx) => {
              let report = {
                no: idx + 1,
                id_report: el.id_report,
                title: el.title,
                description: el.description,
                risk_score: el.risk_score,
                malware_logo: el.malware_logo ?? "cyber-attack.png",
                status_report: el.status_report,
                comments_count: el.comments_count,
                created_at: moment(el.created_at).format("DD/MM/YYYY"),
                malware_data: JSON.parse(el.malware_data),
                tags: JSON.parse(el.tags),
                report_by: el.report_by ?? null,
                verify_by: el.verif_by ?? null,
              };
              this.reports.push(report);
            });
            this.loading.list = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.listReport();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err ->> ", err);
              this.loading.list = false;
            }
          }
        })
        .finally(() => {
          this.$refs.paginate.setPage(1);
        });
    },

    listUser() {
      let ferr = 0;
      UserService.getAllUser()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.listUser();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.tableData = [];
            this.total_users = response.data.data.length;
            response.data.data.forEach((val, index) => {
              const data = {
                no: index + 1,
                id_user: val.id_user,
                username: val.username,
                name: val.name,
              };
              if (val.role == "admn") {
                this.tableDataAdmin.push(data);
              }
              if (val.role == "anly") {
                this.tableDataAdmin.push(data);
              }
              if (val.role == "verf") {
                this.tableDataVerif.push(data);
              }
              // this.loading = false;
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.listUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
          //   this.loading = false;
        });
    },

    searchReport() {
      let ferr = 0;
      const searchData = {
        searchKey: this.searchKey,
      };
      if (this.searchKey != "") {
        this.loading.search = true;
        ReportService.search(searchData)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.listReport();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              this.reports = [];
              res.data.data.forEach((el, idx) => {
                let report = {
                  no: idx + 1,
                  id_report: el.id_report,
                  title: el.title,
                  description: el.description,
                  risk_score: el.risk_score,
                  malware_logo: el.malware_logo ?? "cyber-attack.png",
                  status_report: el.status_report,
                  comments_count: el.comments_count,
                  created_at: moment(el.created_at).format("MM/DD/YYYY"),
                  malware_data: JSON.parse(el.malware_data),
                  tags: JSON.parse(el.tags),
                  report_by: el.report_by ?? null,
                  verify_by: el.verif_by ?? null,
                };
                this.reports.push(report);
              });
              this.loading.search = false;
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.searchReport();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                this.loading.list = false;
                console.log("err ->> ", err);
              }
            }
          });
      }
    },

    searchAdvanced() {
      let ferr = 0;
      const searchDataAdvanced = {
        status_report: this.advancedSearch.status_report,
        report_by: this.advancedSearch.report_by,
        start_created_at: this.advancedSearch.start_created_at,
        end_created_at: this.advancedSearch.end_created_at,
        verif_by: this.advancedSearch.verif_by,
        risk_score: this.advancedSearch.riskscore,
        tag: this.advancedSearch.tag,
      };
      this.loading.search = true;
      ReportService.advancedSearch(searchDataAdvanced)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.listReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.reports = [];
            res.data.data.forEach((el, idx) => {
              let report = {
                no: idx + 1,
                id_report: el.id_report,
                title: el.title,
                description: el.description,
                risk_score: el.risk_score,
                malware_logo: el.malware_logo ?? "cyber-attack.png",
                status_report: el.status_report,
                comments_count: el.comments_count,
                created_at: moment(el.created_at).format("MM/DD/YYYY"),
                malware_data: JSON.parse(el.malware_data),
                tags: JSON.parse(el.tags),
                report_by: el.report_by ?? null,
                verify_by: el.verif_by ?? null,
              };
              this.reports.push(report);
            });
            this.loading.search = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.searchAdvanced();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              this.loading.search = false;
              console.log("err ->> ", err);
            }
          }
        });
    },

    getId(id) {
      return Buffer.from(id).toString("base64");
    },
    onChangePageSize() {
      this.$refs.paginate.setPage(1);
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    changeDisplay(val) {
      this.display = val;
    },
    refresh() {
      setTimeout(() => {
        this.$refs.riskscore.refresh();
      }, 500);
    },

    ResetSearchAdvanced() {
      (this.advancedSearch.status_report = ""),
      (this.advancedSearch.report_by = ""),
      (this.advancedSearch.verif_by = ""),
      (this.advancedSearch.start_created_at = ""),
      (this.advancedSearch.end_created_at = ""),
      (this.advancedSearch.riskscore = 0),
      (this.advancedSearch.tag = "");

      this.listReport();
    },
  },
  mounted() {
    this.listReport();
    this.listUser();
  },
};
</script>
<style>
.page-item.active .page-link {
  background-color: #024284 !important;
  border-color: #024284 !important;
}
.custom-paginate-dark .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #022b3a !important;
}
.custom-paginate .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #eff2f7 !important;
}
</style>